module.exports = __webpack_public_path__ + "static/media/hse.ccb2d197.png";